"use strict";

class PropertyCommissionsController {

    constructor(
        Upload,
        SSHttpService,
        SSUtilService,
        SSAlertService,
        SSConfigService,
        SSUserService,
        OTPService,
        SSDateService,
        SSConfirmationService
    ) {
        const self = this;

        self.Upload = Upload;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSDateService = SSDateService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;
        self.error = {};

        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;

        self.COMMISSION_TYPE_APPOINTED_AGENCY = SHOWSUITE.COMMISSION_TYPE_APPOINTED_AGENCY;
        self.COMMISSION_TYPE_NON_APPOINTED_AGENCY = SHOWSUITE.COMMISSION_TYPE_NON_APPOINTED_AGENCY;
        self.COMMISSION_TYPE_STAFF_REFERRAL = SHOWSUITE.COMMISSION_TYPE_STAFF_REFERRAL;
        self.COMMISSION_TYPE_THIRD_PARTY_REFERRAL = SHOWSUITE.COMMISSION_TYPE_THIRD_PARTY_REFERRAL;
        self.COMMISSION_TYPE_SALE_CONSULTANTS = SHOWSUITE.COMMISSION_TYPE_SALE_CONSULTANTS;
        self.COMMISSION_TYPE_TELE_SALE = SHOWSUITE.COMMISSION_TYPE_TELE_SALE;
        self.COMMISSION_TYPE_MARKETING_SERVICE_FEE = SHOWSUITE.COMMISSION_TYPE_MARKETING_SERVICE_FEE;
        self.COMMISSION_TYPE_POOL = SHOWSUITE.COMMISSION_TYPE_POOL;

        self.selectedStackId = null;
        self.selected_units_count = 0;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.propertyCommissions = null;
        self.selectedPropertyCommissionDataset = null;
        self.selectedModalTitle = null;
        self.propertyCommissionParams = {
            is_active: null,
            data : []
        };

        self.propertyCommissionViewMode = null;
        self.propertyCommissionEditMode = null;

        self.searchCommissionString = '';
        self.actualPropertyCommissions = null;
        self.sortCommissionDataValue = 'created_at';
        self.sortOrder = true;

        self.getPropertyCommissions();

    }

    //-------------------------------------------

    getPropertyCommissions() {
        let self = this;

        let url = 'sec/developer/properties/' + self.data.property.id + '/commissions';

        loading(true);
        self.SSHttpService.getAPIRequest(url, self.propertyCommissionParams).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.propertyCommissions = response.data.property_commissions;
            self.actualPropertyCommissions = self.propertyCommissions;
        });

    }

    savePropertyCommission(update_date = true) {
        let self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            self._savePropertyCommission(update_date);
        });
    }

    _savePropertyCommission(update_date = true) {
        let self = this;

        if (!self.propertyCommissionParams) {
            return;
        }

        if(!self.amountEmptyCheck()){
            return;
        }


        let url = 'sec/developer/properties/' + self.data.property.id + '/commissions';

        //checking Multi select Option
        if(self.propertyCommissionParams.data) {
            for (let i = 0; i < self.propertyCommissionParams.data.length; i++) {
                if (angular.isArray(self.propertyCommissionParams.data[i].dataset) && self.propertyCommissionParams.data[i].dataset.length <= 0) {
                    self.propertyCommissionParams.data[i].multiselect = false;
                }
            }
        }

        let params = angular.copy(self.propertyCommissionParams);

        if(!("incentives_amount_type" in params) && ("incentives_amount_value" in params) || ("incentives_amount_type" in params) && !("incentives_amount_value" in params))
        {
            delete params.incentives_amount_type;
            delete params.incentives_amount_value;
        }

        if(!("commission_amount_type" in params) && ("commission_amount_value" in params) || ("commission_amount_type" in params) && !("commission_amount_value" in params))
        {
            delete params.commission_amount_type;
            delete params.commission_amount_value;
        }

        // In case of unit selection, don't update other parameters
        if(update_date){
            params.availability_start_date = self.SSDateService.formateWithTimeAsNoon(self.propertyCommissionParams.availability_start_date);
            params.availability_end_date = self.SSDateService.formateWithTimeAsNoon(self.propertyCommissionParams.availability_end_date);
        }

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#propertyCommissionForm'))) {
            return;
        }

        //Validating Copies of CommissionDataParams
        if(self.propertyCommissionParams.data) {
            for (let i = 0; i < self.propertyCommissionParams.data.length; i++) {
                let new_array = self.propertyCommissionParams.data.filter(function (inner_val, index) {
                    return self.propertyCommissionParams.data[i].name == inner_val.name;
                });
                if (new_array.length > 1) {
                    new_array.forEach((value) => {
                        value.error = true;
                    });
                    return;
                } else {
                    delete new_array[0].error;
                    for (let j = 0; j < params.data.length; j++) {
                        delete params.data[j].error;
                    }
                }
            }
        }

        if(params.data != null && params.data.length > 0){
            params.data = JSON.stringify(params.data);
        }
        else{
            params.data = null;
        }

        let responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                if(params.type == self.COMMISSION_TYPE_POOL){
                    self.error.message = response.message;
                    $('#errorCommissionModal').modal('show');
                }
                return;
            }

            let existingPropertyCommission = self.selectedPropertyCommission;
            let newPropertyCommission = response.data.property_commission;

            if(newPropertyCommission && newPropertyCommission.data != null){
                newPropertyCommission.data = JSON.parse(newPropertyCommission.data);
            }

            if (existingPropertyCommission && existingPropertyCommission.id) {
                angular.merge(existingPropertyCommission, newPropertyCommission);
            } else {
                self.propertyCommissions.push(newPropertyCommission);
            }

            self.setPropertyCommissionViewMode(false);
            self.setPropertyCommissionViewMode(true,newPropertyCommission);
        };

        loading(true);
        if (self.propertyCommissionParams.id) {
            url += '/' + self.propertyCommissionParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    getValidity(commission){
        const self = this;

        let validity = { validityStatus: '--', validityClass: '' };

        if (commission) {
            // Convert 'Start/End' dates to 'locale' date-time string for time comparison
            let start_date = self.formatUtcToLocalDate(commission.availability_start_date);
            let end_date = self.formatUtcToLocalDate(commission.availability_end_date);
            let today_date = moment(moment().local().format('YYYY-MM-DD HH:mm:ss'));

            // As the second parameter determines the precision, 
            // and not just a single value to check, using day will check for year, month and day.
            // If nothing is passed to moment#isBefore, it will default to the current time.
            // REFERENCE: https://momentjscom.readthedocs.io/en/latest/moment/05-query/01-is-before/

            if (start_date.isSameOrAfter(today_date, 'day') && end_date.isSameOrAfter(today_date, 'day')
                && start_date.diff(today_date, 'minutes') >= 0) {
              validity = { validityStatus: 'Up Coming', validityClass: 'text-primary' };
            }
            else if (end_date.isSameOrAfter(today_date) && today_date.isSameOrAfter(start_date)) {
              validity = { validityStatus: 'Valid', validityClass: 'text-success' };
            }
            else{
              validity = { validityStatus: 'Expired', validityClass: 'text-danger' };
            }
        }
        
        return validity;
    }

    formatUtcToLocalDate(date){
        const self = this;

        try{
            if(typeof date === 'string'){
                // Convert 'date-time' string to UTC 'date-time' object
                var stillUtc = moment.utc(date).toDate();

                // Now convert UTC to local 'date-time' object
                var local = moment(moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss'));  
            }
            else{
                local = date;
            }
        }
        catch(ex){
            console.log(ex);
        }

        return local;
    }

    getParamsDate(date){
        const self = this;

        try{
            if(date != '' && date != null) {
                // Split date and time on the basis of white-space
                var date_time = date.split(" ");

                var date = date_time[0];

                if(date_time.length > 1){
                    var time = date_time[1];
                    // Server accepts time as 'hh:mm:ss' but jQuery timepicker is 'hh:mm'
                    if(time.split(':').length == 2){
                        time = time + ':00';
                    }
                }

                if(date.includes("-")){
                    var date_format = date + ' ' + time;
                }
                else{
                    var res = date.split("/", 3);
                    var date_format = res[2] + '-' + res[1] + '-' + res[0] + ' ' + time;
                }

                if(date_format) {
                    // var localDate = new Date(self.parseDate(date_format));
                    var utcFormat = moment(date_format).utc().format('YYYY-MM-DD HH:mm:ss');
                }

                return utcFormat;
            }
            else{
                return null;
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    parseDate(date) {
        const self = this;
        
        const parsed = Date.parse(date);
        if (!isNaN(parsed)) {
            return parsed;
        }

        return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
    }

    getFormattedDate(date){
        const self = this;

        try{
            if(date){
                var local = self.UtctoLocal(date);

                return local;
            }
            else{
                return '--';
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    UtctoLocal(UTCDateString){
        const self = this;

        var convertdLocalTime = new Date(UTCDateString);

        var hourOffset = convertdLocalTime.getTimezoneOffset() / 60;

        convertdLocalTime.setHours(convertdLocalTime.getHours() -  hourOffset);

        var dateObj = new Date(convertdLocalTime);

        var _date = self.dateFormat(dateObj);

        return _date;
    }

    dateFormat(now) {
        const self = this;

        var year = "" + now.getFullYear();
        var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
        var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
        var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
        var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
        var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }

        return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    }

    deletePropertyCommission(propertyCommissionId) {
        let self = this;

        if (!propertyCommissionId)
            return;

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/properties/' + self.data.property.id + '/commissions/' + propertyCommissionId + '/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if(response.code == 409 && response.message){
                            self.SSAlertService.danger("Error!", response.message);
                        }
                        else{
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    // Remove from local data
                    jQuery.each(self.propertyCommissions, function (i, o) {
                        if (o.id == propertyCommissionId) {
                            self.propertyCommissions.splice(i, 1);
                            return false;
                        }
                    });
                });
            }
        );
    }

    //-------------------------------------------

    formatCommissionValue(type, value) {

        const self = this;

        if (!(type || value)) {
            return '--';
        }

        let _value = value;

        if (type == self.VALUE_TYPE_PERCENTAGE) {
            _value = _value + ' %';
        } else if (type == self.VALUE_TYPE_AMOUNT) {
            _value = self.SSUtilService.formatCurrency(_value);
        }

        return _value;
    }

    formatIncentiveValue(type, value) {

        const self = this;

        if (!(type) || !(value)) {
            return '--';
        }

        let _value = value;

        if (type == self.VALUE_TYPE_PERCENTAGE) {
            _value = _value + ' %';
        } else if (type == self.VALUE_TYPE_AMOUNT) {
            _value = self.SSUtilService.formatCurrency(_value);
        }

        return _value;
    }

    toggleActiveAndLoadPropertyCommissions(isActive) {
        const self = this;

        if (isActive == true) {
            self.propertyCommissionParams.is_active = self.propertyCommissionParams.is_active != true ? true : null;
        }
        if (isActive == false) {
            self.propertyCommissionParams.is_active = self.propertyCommissionParams.is_active != false ? false : null;
        }

        self.getPropertyCommissions();
    }

    //-------------------------------------------

    setPropertyCommissionViewMode(mode, propertyCommission) {
        const self = this;

        if (mode) {
            self.selectedPropertyCommission = propertyCommission;
            try{
                self.propertyCommissionParams.commission_gst_inclusive = self.selectedPropertyCommission.commission_gst_inclusive;
                self.propertyCommissionParams.incentives_gst_inclusive = self.selectedPropertyCommission.incentives_gst_inclusive;
            }
            catch (e) {
                self.propertyCommissionParams.commission_gst_inclusive = false;
                self.propertyCommissionParams.incentives_gst_inclusive = false;
            }
            if(self.selectedPropertyCommission && self.selectedPropertyCommission.data && self.selectedPropertyCommission.data.length > 0 && (typeof self.selectedPropertyCommission.data === "string")) {
                try {
                    self.selectedPropertyCommission.data = JSON.parse(self.selectedPropertyCommission.data);
                }
                catch (e) {
                    self.selectedPropertyCommission.data = null;
                    console.log("Malformed Data Received");
                }
            }
            if (!self.selectedPropertyCommission) {
                self.setPropertyCommissionEditMode(mode);
            }
        } else {
            self.selectedPropertyCommission = null;
            self.setPropertyCommissionEditMode(mode);
        }

        self.propertyCommissionViewMode = mode;
        self.propertyCommissionAmountError = null;
    }

    getLocaleDateTime(date_time){
        const self = this;

        let parsed_date = '--';

        if(!date_time){
            return parsed_date;
        }

        try{
            parsed_date = moment(moment.utc(date_time).toDate()).local().format('DD/MM/YYYY HH:mm:ss')
        }
        catch(ex){
            console.log(ex);
        }

        return parsed_date;
    }

    setPropertyCommissionEditMode(mode) {
        const self = this;

        if (mode) {
            if (self.selectedPropertyCommission) {
                self.propertyCommissionParams = angular.copy(self.selectedPropertyCommission);

                let start_date = self.propertyCommissionParams.availability_start_date;
                let end_date = self.propertyCommissionParams.availability_end_date;

                // Format Date Time to local string
                if(start_date){
                    self.propertyCommissionParams.availability_start_date = self.SSUtilService.formatUtcToLocalDate(start_date);
                }
                if(end_date){
                    self.propertyCommissionParams.availability_end_date = self.SSUtilService.formatUtcToLocalDate(end_date);
                }

                if(typeof self.propertyCommissionParams.data === "string") {
                    self.propertyCommissionParams.data = JSON.parse(self.propertyCommissionParams.data);
                }

            } else {
                self.propertyCommissionParams = {};
            }
        } else {
            self.propertyCommissionParams = {};
            if (!self.selectedPropertyCommission) {
                self.propertyCommissionViewMode = mode;
            }
        }

        self.propertyCommissionEditMode = mode;
    }

    parseDataObject(selectedPropertyCommissionData){
        const self = this;

        if(selectedPropertyCommissionData) {
            return JSON.parse(selectedPropertyCommissionData.toString());
        }
        else
            return null;
    }

    viewDetails(propertyCommissionData){
        const self = this;
        self.selectedPropertyCommissionDataset = propertyCommissionData.dataset;
        self.selectedModalTitle = propertyCommissionData.name;
        jQuery('#CommissionDataSetModal').modal('show');
    }

    addNewData(){
        const self = this;
        if(!self.propertyCommissionParams.data)
            self.propertyCommissionParams.data = [];
        self.propertyCommissionParams.data.push({"name":"","is_required":false,"dataset":[]});
    }

    addNewDataSet(){
        const self = this;
        self.selectedPropertyCommissionDataset.push({"id":"","name":""});
    }

    deleteDataElement(propertyCommissionData){
        const self = this;
        let element = jQuery.inArray(propertyCommissionData,self.propertyCommissionParams.data);
        if(-1 != element){
            self.propertyCommissionParams.data.splice(element,1);
        }
    }

    deleteDataSetElement(commissionDataSet){
        const self = this;
        let element = jQuery.inArray(commissionDataSet,self.selectedPropertyCommissionDataset);
        if(-1 != element){
            self.selectedPropertyCommissionDataset.splice(element,1);
        }
    }

    saveDataSet(selectedPropertyCommissionDataset){
        const self = this;
        for (let i = 0 ; i < selectedPropertyCommissionDataset.length ; i++) {
            let new_array = selectedPropertyCommissionDataset.filter(function (inner_val, index) {
                return selectedPropertyCommissionDataset[i].id == inner_val.id;
            });
            if (new_array.length > 1) {
                new_array.forEach((value) => {
                    value.error = true;
                });
                return;
            } else {
                delete new_array[0].error;
            }
        }
        if(self.propertyCommissionParams.data && self.propertyCommissionParams.data.dataset) {
            self.propertyCommissionParams.data.dataset = selectedPropertyCommissionDataset;
        }
        if(self.selectedPropertyCommission && self.selectedPropertyCommission.data && self.selectedPropertyCommission.data.dataset) {
            self.selectedPropertyCommission.data.dataset = self.selectedPropertyCommissionDataset;
        }
        jQuery('#CommissionDataSetModal').modal('hide');
    }

    cancelDataSetEdit(){
        const self = this;
        self.propertyCommissionParams.data.dataset = self.selectedPropertyCommissionDataset;
        jQuery('#CommissionDataSetModal').modal('hide');
    }
    //-------------------------------------------

    amountEmptyCheck(){
        const self = this;
        if(self.propertyCommissionParams.commission_amount_value == null && self.propertyCommissionParams.incentives_amount_value == null || self.propertyCommissionParams.commission_amount_value === 0 && self.propertyCommissionParams.incentives_amount_value === 0){
                self.propertyCommissionAmountError = 'Please specify Commission Value or Incentive value, both cannot be Empty or Zero';
                return false;
        }
        else if(self.propertyCommissionParams.commission_amount_value == null && self.propertyCommissionParams.incentives_amount_value === 0 || self.propertyCommissionParams.commission_amount_value === 0 && self.propertyCommissionParams.incentives_amount_value == null){
            self.propertyCommissionAmountError = 'Please specify Commission Value or Incentive value, both cannot be Empty or Zero';
            return false;
        }
        if(("commission_amount_value" in self.propertyCommissionParams) && self.propertyCommissionParams.commission_amount_value !== 0 && !("commission_amount_type" in self.propertyCommissionParams)){
            self.propertyCommissionAmountError = 'Please specify Commission Type it must be selected';
            return false;
        }
        if(("incentives_amount_value" in self.propertyCommissionParams) && self.propertyCommissionParams.incentives_amount_value !== 0 && !("incentives_amount_type" in self.propertyCommissionParams)){
            self.propertyCommissionAmountError = 'Please specify Incentives Type it must be selected';
            return false;
        }
        if(self.propertyCommissionParams.commission_amount_type == self.VALUE_TYPE_PERCENTAGE && (self.propertyCommissionParams.commission_amount_value > 100 || self.propertyCommissionParams.commission_amount_value < 0)){
            self.propertyCommissionAmountError = 'Value in percentage must be <= 100 and > 0';
            return false;
        }
        if(self.propertyCommissionParams.incentives_amount_type == self.VALUE_TYPE_PERCENTAGE && (self.propertyCommissionParams.incentives_amount_value > 100 || self.propertyCommissionParams.incentives_amount_value < 0)){
            self.propertyCommissionAmountError = 'Value in percentage must be <= 100 and > 0';
            return false;
        }
        self.propertyCommissionAmountError = null;
        return true;
    }

    searchCommissions(){
        const self = this;
        if(self.searchCommissionString.length > 0 && self.propertyCommissions && self.propertyCommissions.length > 0){
            self.propertyCommissions = self.propertyCommissions.filter((value)=>{
                if(value.name){
                    return value.name.toLowerCase().includes(self.searchCommissionString);
                }
            });
        }
        else{
            self.propertyCommissions = self.actualPropertyCommissions;
        }
    }

    sortCommissionData(value){
        const self = this;
        if(value != self.sortCommissionDataValue) {
            self.sortCommissionDataValue = value;
            self.sortOrder = false;
        }
        else {
            self.sortOrder = !self.sortOrder;
        }
    }

    getSortClass(column){
        const self = this;

        if(self.sortCommissionDataValue == column){
            return !self.sortOrder ? 'fa-caret-down':'fa-caret-up';
        }
        return '';
    }

    formatUtcToLocalDateTime(date_time){
        const self = this;

        let parsed_date = '--';

        if(!date_time){
            return parsed_date;
        }

        try{
            parsed_date = moment(moment.utc(date_time).toDate()).local().format('DD/MM/YYYY HH:mm')
        }
        catch(ex){
            console.log(ex);
        }

        return parsed_date;
    }
}

PropertyCommissionsController.$inject = [
    'Upload',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSConfigService',
    'SSUserService',
    'OTPService',
    'SSDateService',
    'SSConfirmationService'
];
app.controller('PropertyCommissionsController', PropertyCommissionsController);

// WEB-4411/WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js.
// A copy here would link it a second time on every element.
